import { render, staticRenderFns } from "./NextcloudNotifications.vue?vue&type=template&id=1fe3484f&scoped=true"
import script from "./NextcloudNotifications.vue?vue&type=script&lang=js"
export * from "./NextcloudNotifications.vue?vue&type=script&lang=js"
import style0 from "./NextcloudNotifications.vue?vue&type=style&index=0&id=1fe3484f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe3484f",
  null
  
)

export default component.exports